import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Box, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';

import type { INote } from '../../../../stores/JobApplicationStore/Note';

import translations from './.vocab';
import FieldLine from './FieldLine';
import HtmlContent from './HtmlContent';
import TimelineItem from './TimelineItem';

interface Props {
  note: INote;
  locale: Locale;
}

const NoteItem: React.FC<Props> = ({ note, locale }) => {
  const { t } = useTranslations(translations);
  return (
    <TimelineItem date={note.createdDate} locale={locale}>
      <Stack space="small">
        <FieldLine title={t('From')} content={note.createdUser} />
        <Box marginY="small">
          <Stack space="xxsmall">
            <HtmlContent content={note.content} />
          </Stack>
        </Box>
      </Stack>
    </TimelineItem>
  );
};

export default observer(NoteItem);
